import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { of, switchMap, take } from 'rxjs';
import { CONFIGURE_DEFAULT_PARAMS, LoadGridPayload } from '@data-access/shared';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { StudyDetailsFacadeService } from '@shared/study-details-facade.service';
import { organizationSiteListTokenizer } from '../store';
import { SiteGridTypes } from '../types';

export const siteListResolver = (route: ActivatedRouteSnapshot) => {
  const _siteSignalStore = organizationSiteListTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);

  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );

  const gridType: SiteGridTypes = route.data.type ?? 'main';

  const loadGrid = (id: string) => {
    const payload: LoadGridPayload = { params: _params };

    _siteSignalStore.setByURL(gridType, id);
    _siteSignalStore.loadSiteGrid(payload);

    return of(true);
  };

  if (gridType === 'study') {
    const studyId = route.paramMap.get('studyId') ?? '';
    if (!studyId) {
      console.error('siteListResolver: Missing studyId in route params');
      return of(null);
    }
    const studyFacade = inject(StudyDetailsFacadeService);

    return studyFacade.loadStudyDetailFn(studyId).pipe(
      take(1),
      switchMap((studyDetails) => loadGrid(studyDetails?.id ?? '')),
    );
  }

  const id =
    route.paramMap.get('id') ?? route.parent?.data['contactId'] ?? '';
  return loadGrid(id);
};
